import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormItemSearch from 'components/forms/FormItemSearch';

class LeadItems extends EntityPropsUpdater {
  addItem = item => {
    if (item) {
      const { entity, changeEntity } = this.props;

      if (_findIndex(entity.getItems(), o => o.item.id === item.id) === -1) {
        // do not allow duplicates
        const newItem = entity.createValue('items', [], { item });
        const newValue = entity.getItems().slice();
        newValue.push(newItem);
        const newEntity = { ...entity.updateValue('items', newValue, []) };

        changeEntity(newEntity);
      }
    }
  };

  removeEntry = index => {
    const { entity, changeEntity } = this.props;
    const newValue = entity.getItems().slice();
    newValue.splice(index, 1);
    const newEntity = { ...entity.updateValue('items', newValue, []) };

    changeEntity(newEntity);
  };

  render() {
    const { entityLoaded, disabled } = this.props;

    if (entityLoaded) {
      return (
        <div class="clearfix padding-25 sm-padding-10">
          <Row>
            <Col xs={12}>
              <div class="panel panel-transparent">
                <div className="form-group-attached">
                  <FormItemSearch onSelect={(name, item) => this.addItem(item)} disabled={disabled} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return null;
  }
}
LeadItems.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadItems);
